import React from 'react';

import { toast } from 'react-toastify';

import { Alert } from '@icarros/ids-react';

import 'react-toastify/dist/ReactToastify.min.css';

const toastify = {
  error: (title: string, msg: string): string | number => {
    toast.dismiss();
    return toast(<Alert variant="error" title={title} body={msg} />, {
      closeButton: false,
      position: 'top-center',
      hideProgressBar: true
    });
  },
  success: (title: string, msg: string): string | number => {
    toast.dismiss();
    return toast(<Alert variant="success" title={title} body={msg} />, {
      closeButton: false,
      position: 'top-center',
      hideProgressBar: true
    });
  },
  info: (title: string, msg: string): string | number => {
    toast.dismiss();
    return toast(<Alert variant="neutral" title={title} body={msg} />, {
      closeButton: false,
      position: 'top-center',
      hideProgressBar: true
    });
  }
};

export default toastify;
